interface IconProps {
  className?: string;
}

export function VercelIcon({ className }: IconProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="currentColor"
      className={className}
      aria-hidden="true"
    >
      <path d="M24 22.525H0l12-21.05 12 21.05z" />
    </svg>
  );
}
